import React from "react";

function MainProgressLoader() {
  return (
    <div className=" h-48 flex flex-col items-start justify-center border-borderdark rounded-xl py-2 px-4 m-auto animate-pulse gap-y-2">
     <div className=" w-full flex justify-between items-center">
      <div class="h-4 rounded-full bg-gray-100  w-32"></div>
      <div class="h-4 rounded-full bg-gray-100  w-32"></div>

     </div>
      <div className=" w-full px-4 flex justify-between items-center">     
      {[...Array(10)].map((_, index) => {
          return (
            <div className=" flex flex-col gap-2 items-center justify-center w-24 h-32" key={index}>
                <div className="h-5 rounded-full bg-gray-100  w-20"></div>
                <div className=" h-20 w-20 border p-1">
                    <div className=" h-16 w-16 bg-gray-100 rounded-full flex justify-center items-center">
                      <div className=" w-8 h-8 rounded-full bg-white"></div>
                    </div>
                </div>
            </div>
          );
        })}
      </div>      
      <div class="h-6 bg-gray-100  w-full"></div>
    </div>
  );
}

export default MainProgressLoader;
